var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrp"},[_c('div',[_c('b-container',{staticClass:"anns",attrs:{"fluid":""}},[_c('b-row',{staticClass:"annslist"},[_c('b-col',[_c('b-img',{attrs:{"src":_vm.priceListURL,"fluid":""}})],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578526d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MobilePriceListView.vue
// module id = null
// module chunks = 